import { ListFilter, Plus } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'
import { cn } from '@/lib/utils'

import type { ApartmentFilterOptions } from '@services/livability/types'

import type { ApartmentFilters } from '../../utils/apartmentFilterUrl'
import { QUICK_FILTER_IDS, isFilterDefOffered, type FilterDef } from './filterDefs'

interface AddFilterMenuProps {
  availableDefs: FilterDef[]
  filters: ApartmentFilters
  filterOptions?: ApartmentFilterOptions
  onSelect: (def: FilterDef) => void
}

export function AddFilterMenu({
  availableDefs,
  filters,
  filterOptions,
  onSelect
}: AddFilterMenuProps) {
  const selectable = availableDefs.filter((def) =>
    isFilterDefOffered(def, filters, filterOptions)
  )

  if (selectable.length === 0) return null

  const quickInMenu = selectable.filter((d) =>
    (QUICK_FILTER_IDS as readonly string[]).includes(d.id)
  )
  const restInMenu = selectable.filter(
    (d) => !(QUICK_FILTER_IDS as readonly string[]).includes(d.id)
  )

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          size="sm"
          variant="outline"
          className={cn(
            'gap-2 rounded-full border-dashed border-ink/25 px-4 py-2',
            'font-medium text-ink shadow-none',
            'hover:border-primary/40 hover:bg-primary/[0.04] hover:text-primary'
          )}
        >
          <Plus className="h-4 w-4" />
          Filter
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        {quickInMenu.length > 0 && (
          <>
            <DropdownMenuLabel className="flex items-center gap-2 text-xs text-muted-foreground">
              <ListFilter className="h-3.5 w-3.5" />
              Často používané
            </DropdownMenuLabel>
            {quickInMenu.map((def) => (
              <DropdownMenuItem key={def.id} onSelect={() => onSelect(def)}>
                {def.label}
              </DropdownMenuItem>
            ))}
            {restInMenu.length > 0 && <DropdownMenuSeparator />}
          </>
        )}
        {restInMenu.map((def) => (
          <DropdownMenuItem key={def.id} onSelect={() => onSelect(def)}>
            {def.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
